import { createContext, useContext, useMemo, useState } from 'react';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OpenPopoverContext = /*#__PURE__*/createContext(undefined);
export const OpenPopoverProvider = ({
  children
}) => {
  const [openPopover, setOpenPopover] = useState();
  const value = useMemo(() => {
    return {
      showPopover: setOpenPopover,
      hidePopover: () => setOpenPopover(undefined)
    };
  }, []);
  return /*#__PURE__*/_jsxs(OpenPopoverContext.Provider, {
    value: value,
    children: [/*#__PURE__*/_jsx(_Fragment, {
      children: openPopover
    }), children]
  });
};
export const usePopover = () => {
  const context = useContext(OpenPopoverContext);
  if (context === undefined) {
    throw new Error('usePopover must be used within a OpenPopoverProvider');
  }
  return {
    showPopover: popover => context.showPopover(popover),
    hidePopover: () => context.hidePopover()
  };
};